import ApiPaths from 'rde-view-common/constants/ApiPaths';
import Routes from 'rde-view-common/constants/Routes';
import { getNestedVal, isEmpty, isNotEmpty, isNotNull, isNotUndefined, sleep } from 'rde-view-common/scripts/functions';
import StoreUtils from 'rde-view-common/scripts/storeUtils';

/**
 * ログイン中のユーザ情報の取得、及びアクセス権限の制御を行うmiddleware
 */
export default async function ({ app, route, $axios, redirect, $config }) {
  // エラー画面の場合は処理を行わない。
  const currentPath =
    isNotEmpty(getNestedVal(route, 'matched', 0, 'path')) ? route.matched[0].path.replaceAll('?', '') : '/';
  console.log('currentPath:', route.fullPath);
  // StoreUtilsにrouteをinjection
  StoreUtils.$currentPath = route.path === Routes.ENTRIES_LIST.path ? Routes.ENTRIES_LIST.path : route.fullPath;
  if (currentPath === Routes.COMMON_ERROR.path || currentPath === Routes.COMMON_LOGOUT.path) return;
  if (currentPath === '/' && isNotEmpty($config.name) && $config.name !== 'production') return;

  // Routesに定義されていない場合はエラー
  const routes = Object.values(Routes).filter(routeObj => currentPath === routeObj.path);
  if (isEmpty(routes)) {
    app.store.commit('systemErrorObj', { status: '404', message: app.$msg(app.$msgIds.MSG_COM_W_0430) });
    await redirect(app.$routes.COMMON_ERROR.path);
    await sleep(1000);
    return;
  }

  const loginUserData = await getSelf($axios, app.store);

  // Routesに'isAccessible'が定義されている場合は実行しチェックを行う。
  if (isNotNull(routes[0].isAccessible)
    && routes[0].isAccessible instanceof Function
    && !routes[0].isAccessible(loginUserData)) {
    // 権限がない場合はエラー画面へ遷移する。
    app.store.commit('systemErrorObj', { status: '403', message: app.$msg(app.$msgIds.MSG_COM_W_0420) });
    await redirect(app.$routes.COMMON_ERROR.path);
    await sleep(1000);
  }
}

async function getSelf(axios, store) {
  // ログインユーザの情報を取得(storeに保持し、使い回す。)
  let loginUserData = store.state.loginUser;
  if (isEmpty(loginUserData.id)) {
    console.log('notstored');
    const response = await axios.get(ApiPaths.USERS_SELF);
    const data = getNestedVal(response, 'data', 'data');
    loginUserData = isNotUndefined(data)
      ? {
        id: data.id,
        name: data.attributes.userName,
        organizationName: data.attributes.organizationName,
        role: data.attributes.role
      }
      : { id: '', name: '', organizationName: '', role: '' };
    store.commit('loginUser', loginUserData);
  }
  console.log('logged in user:', loginUserData);
  return loginUserData;
}
